const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export function getToken() {
  try {
    const stored = JSON.parse(localStorage.getItem('madjeo_auth'));
    if (stored?.accessToken) return stored.accessToken;
  } catch { /* ignore */ }
  return (
    localStorage.getItem('access_token') ||
    localStorage.getItem('auth_token') ||
    null
  );
}

function getRefreshToken() {
  try {
    const stored = JSON.parse(localStorage.getItem('madjeo_auth'));
    if (stored?.refreshToken) return stored.refreshToken;
  } catch { /* ignore */ }
  return localStorage.getItem('refresh_token') || null;
}

function saveNewAccess(newAccess) {
  try {
    const stored = JSON.parse(localStorage.getItem('madjeo_auth')) || {};
    stored.accessToken = newAccess;
    localStorage.setItem('madjeo_auth', JSON.stringify(stored));
  } catch { /* ignore */ }
}

export function getAuthHeaders(extra = {}) {
  const token = getToken();
  return {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...extra,
  };
}

// Même logique que l'intercepteur Axios de client.js, mais pour fetch() natif.
// Rafraîchit le token sur 401 et relance la requête une seule fois.
let _isRefreshing   = false;
let _refreshQueue   = [];

function flushQueue(error, token) {
  _refreshQueue.forEach(({ resolve, reject }) => error ? reject(error) : resolve(token));
  _refreshQueue = [];
}

export async function fetchWithAuth(url, options = {}) {
  const doFetch = (token) => {
    const headers = { ...(options.headers || {}), ...(token ? { Authorization: `Bearer ${token}` } : {}) };
    return fetch(url, { ...options, headers });
  };

  let res = await doFetch(getToken());
  if (res.status !== 401) return res;

  // 401 → tenter un refresh
  const refreshToken = getRefreshToken();
  if (!refreshToken) {
    window.dispatchEvent(new Event('madjeo:logout'));
    return res;
  }

  if (_isRefreshing) {
    // Une autre requête rafraîchit déjà — on attend
    const newToken = await new Promise((resolve, reject) => _refreshQueue.push({ resolve, reject }));
    return doFetch(newToken);
  }

  _isRefreshing = true;
  try {
    const refreshRes = await fetch(`${BASE_URL}/api/v1/auth/token/refresh/`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ refresh: refreshToken }),
    });
    if (!refreshRes.ok) throw new Error('refresh_failed');
    const { access: newAccess } = await refreshRes.json();
    saveNewAccess(newAccess);
    flushQueue(null, newAccess);
    return doFetch(newAccess);
  } catch (err) {
    flushQueue(err, null);
    window.dispatchEvent(new Event('madjeo:logout'));
    return res;
  } finally {
    _isRefreshing = false;
  }
}
